var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        switchFullscreen: false,
        fullscreen: false,
        cancelText: "关闭"
      },
      on: {
        ok: function($event) {
          _vm.visible = false
        },
        cancel: function($event) {
          _vm.visible = false
        }
      }
    },
    [
      _c(
        "a-list",
        {
          staticStyle: { height: "98%" },
          attrs: { "item-layout": "horizontal" }
        },
        _vm._l(_vm.imgList, function(obj2, key) {
          return _c("a-list-item", { key: key }, [
            _c("img", {
              staticStyle: { width: "100%" },
              attrs: { alt: "example", src: obj2.src },
              on: {
                click: function($event) {
                  return _vm.handleImgView(obj2.src)
                }
              }
            })
          ])
        }),
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "a-button",
            {
              key: "submit",
              attrs: { type: "default" },
              on: {
                click: function($event) {
                  _vm.visible = false
                }
              }
            },
            [_vm._v(" 关闭 ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }